import { ColumnDefinitionType } from "./Table";
import React, { useEffect, useState } from "react";
import Input from "../customhtmlcomponents/Input";
import TableOptionsGaverBidrag from "../gaverbidrag/TableOptionsGaverBidrag";
import TableOptionsEiendomType from "../eiendom/eiendomtableoptions/TableOptionsEiendomType";
import TableOptionsEiendomLeietaker from "../eiendom/eiendomtableoptions/TableOptionsEiendomLeietaker";
import TableOptionsEiendomDriftsform from "../eiendom/eiendomtableoptions/TableOptionsEiendomDriftsform";

export type TableRowsProps<T, K extends keyof T> = {
  data: Array<T>;
  columns: Array<ColumnDefinitionType<T, K>>;
  removeRow: (id: number) => void;
  handleChange: any;
  addRow?: () => void;
  isAdmin: boolean;
  showRowActions: boolean;
  entityName?: string;
};

const tdClassName = "border-sk-tertiary-blue border-r-2 p-4";
const tdBeskrivelseClassName =
  "border-sk-tertiary-blue border-r-2 p-4 lg:w-2/4 w-1/3";
const labelStyle = { labelOn: false, defaultLabelStyle: true };

const TableRows = <T, K extends keyof T>({
  data,
  columns,
  removeRow,
  handleChange,
  addRow,
  isAdmin,
  showRowActions
}: TableRowsProps<T, K>): JSX.Element => {
  const [rowData, setRowData] = useState(data);
  useEffect(() => {
    setRowData(data);
  }, [handleChange]);
  const keys = rowData?.flatMap(
    (t) =>
      Object.keys(t)
        .filter((k) => k === "id")
        //@ts-ignore
        .map((key) => t[key]) ?? columns.map((c) => c.key === "id")
  ) as number[];
  // @ts-ignore
  const rows = rowData.map((row, index) => {
    return (
      <tr
        className="border-sk-tertiary-blue border-t border-b"
        key={`row-${index}`}
        id={keys[index] as unknown as string}
      >
        {columns.map((column, index2) => {
        const uniqueKey = `${index}-${index2}`
          const isUserEditingAdminColumn = column.editAsAdminOnly === true && !isAdmin
          if (column.key === "type") {
            return (
              <td key={`cell-${index2}`} className={tdClassName}>
                <TableOptionsEiendomType
                  id={`eiendomType-${uniqueKey}`}
                  handleChange={handleChange}
                  index={row}
                  disabled={isUserEditingAdminColumn}
                />
              </td>
            );
          } else if (column.key === "leietaker") {
            return (
              <td key={`cell-${index2}`} className={tdClassName}>
                <TableOptionsEiendomLeietaker
                  id={`eiendomLeieTaker-${uniqueKey}`}
                  handleChange={handleChange}
                  index={row}
                  disabled={isUserEditingAdminColumn}
                />
              </td>
            );
          } else if (column.key === "driftsform") {
            return (
              <td key={`cell-${index2}`} className={tdClassName}>
                <TableOptionsEiendomDriftsform
                  id={`driftsform-${uniqueKey}`}
                  handleChange={handleChange}
                  index={row}
                  disabled={isUserEditingAdminColumn}
                />
              </td>
            );
          } else if (column.key === "belop" || column.key === "omsetning") {
            return (
              <td
                key={`cell-${index2}`}
                className={tdClassName + " flex justify-end"}
              >
                <Input
                  flex={!!column.textStyle}
                  className={`${column.textStyle ?? "flex text-right pr-2"}`}
                  name={column.key as string}
                  label={""}
                  id={`${String(column.key)}-${index2}-${index}`}
                  labelopts={labelStyle}
                  placeholder={column.header}
                  value={row[column.key] as unknown as string}
                  isNumberField={true}
                  type="text"
                  onChange={(e) => handleChange(e, row)}
                  disabled={isUserEditingAdminColumn}
                />
                <span className="flex text-sm border border-2 px-1 rounded-r py-2 bg-gray-300 whitespace-no-wrap">
                  <span className="flex items-center px-2">NOK</span>
                </span>
              </td>
            );
          } else if (column.key === "alternativ") {
            return (
              <td
                colSpan={column.colSpan}
                key={`cell-${index2}`}
                className={tdClassName}
              >
                <TableOptionsGaverBidrag
                  id={`gaverbidrag-${uniqueKey}`}
                  handleChange={handleChange}
                  index={row}
                />
              </td>
            );
          } else
            return (
              <td
                colSpan={column.colSpan}
                key={`cell-${index2}`}
                className={
                  column.isWide
                    ? tdClassName + " w-full"
                    : tdBeskrivelseClassName
                }
              >
                <Input
                  flex={true}
                  //@ts-ignore
                  key={row.id}
                  className={`${column.textStyle ?? "flex flex-grow"}`}
                  id={`eiendom-${String(column.key)}-${uniqueKey}`}
                  label=""
                  isNumberField={column.isNumberField}
                  labelopts={labelStyle}
                  type={column.inputType}
                  placeholder={column.header}
                  name={column.key as string}
                  value={row[column.key] as unknown as string}
                  onChange={(e) => handleChange(e, row)}
                  disabled={isUserEditingAdminColumn}
                />
              </td>
            );
        })}
        {showRowActions && (
        <>
            {index === rowData.length - 1 ? (
            <td>
              <button
                type="button"
                onClick={addRow}
                className="flex flex-col items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110 mx-auto"
              >
                <svg className="w-10 h-10 " viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"
                  />
                </svg>
                <p>Ny rad</p>
              </button>
            </td>
          ) : (
            <td>
              <button
                type="button"
                onClick={
                  //@ts-ignore
                  () => removeRow(row.id)
                }
                className="flex flex-col items-center transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110 mx-auto"
              >
                <svg className="w-10 h-10 " viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"
                  />
                </svg>
                <p>Fjern rad</p>
              </button>
            </td>
          )}
        </>)}
      </tr>
    );
  });

  return <tbody>{rows}</tbody>;
};

export default TableRows;
